var map = {
	"./": 8370,
	"./__mocks__": 9076,
	"./__mocks__/": 9076,
	"./__mocks__/index": 9076,
	"./__mocks__/index.ts": 9076,
	"./index": 8370,
	"./index.js": 8370,
	"./react-native/0.57": 740,
	"./react-native/0.57.tsx": 740,
	"./react-native/0.58": 6535,
	"./react-native/0.58.tsx": 6535,
	"./react-native/0.59": 4382,
	"./react-native/0.59.tsx": 4382,
	"./react-native/0.60": 1556,
	"./react-native/0.60.tsx": 1556,
	"./react-native/0.61": 4551,
	"./react-native/0.61.tsx": 4551,
	"./react-native/0.62": 4767,
	"./react-native/0.62.tsx": 4767,
	"./react-native/0.64": 2536,
	"./react-native/0.64.tsx": 2536,
	"./react-native/0.68": 4300,
	"./react-native/0.68.tsx": 4300,
	"./react-native/0.69": 5958,
	"./react-native/0.69.tsx": 5958,
	"./react-native/0.71": 7257,
	"./react-native/0.71.tsx": 7257,
	"./react-native/0.72": 6706,
	"./react-native/0.72.tsx": 6706,
	"./react-native/0.73": 8068,
	"./react-native/0.73.tsx": 8068,
	"./react-native/0.74": 8952,
	"./react-native/0.74.tsx": 8952,
	"./react-native/0.77": 2017,
	"./react-native/0.77.tsx": 2017,
	"./types.d": 837,
	"./types.d.ts": 837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2807;